import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import ChevronDownGray from '../../../../assets/icons/chevron_down.svg';
import ChevronDis from '../../../../assets/icons/chevron_dis.svg';

const CategorySection = styled.div``;

const CategoryTitle = styled.h3`
  font-family: Hind;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: ${select('black')};
  margin-bottom: 16px;
  position: relative;
`;

const CategoriesGroup = styled.div`
  display: grid;
  grid-template-columns: ${({ device }) => (device === 'mobile' ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)')};
  row-gap: ${({ device }) => (device === 'desktop' ? '16px' : '8px')};
  column-gap: 24px;
`;

const SelectContainer = styled.div`
  position: relative;
  width: 100%;
  font-family: Hind;
`;

const SelectLabel = styled.div`
  display: block;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: ${select('black')};
  margin-bottom: 4px;
  margin-top: 4px;
  ${({ disabled }) =>
    disabled &&
    css`
      color: ${select('midNeutralGray')};
    `}
`;

const SelectHeader = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 8px 8px 12px;
  background-color: ${select('white')};
  border-radius: 8px;
  border: 1px solid ${({ isOpen }) => (isOpen ? getColor('primary') : select('midDarkGrayAux'))};
  overflow: hidden;
  cursor: pointer;
  ${({ disabled }) =>
    disabled
      ? css`
          color: ${select('midNeutralGray')};
          background-color: ${select('neutralGray')};
          border: 1px solid ${select('midNeutralGray')};
          cursor: default;
        `
      : css`
          &:hover {
            border-color: ${getColor('primary')};
          }
        `}
  ${({ error }) =>
    error &&
    css`
      border-color: ${select('redNoTRecommended')};
    `}
`;

const SelectPlaceholder = styled.span`
  font-size: 14px;
  color: ${({ isDisabled }) => (isDisabled ? select('midNeutralGray') : select('midDarkGrayAux'))};
`;

const SelectContentWrapper = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
`;

const SelectValue = styled.div`
  font-size: 14px;
  color: ${select('black')};
  max-width: ${({ device }) => {
    if (device === 'mobile') return '253px';
    if (device === 'tablet') return '162px';
    return '200px';
  }};
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CloseIconWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin: 0px 8px 1px 4px;
  padding: 5px;
  flex-shrink: 0;

  svg {
    position: relative;
  }

  &::before {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    transition: background-color 0.2s ease;
    z-index: 1;
  }

  &:hover::before {
    background-color: rgba(255, 0, 0, 0.25);
  }
`;

const ArrowIcon = styled.span`
  width: 20px;
  height: 20px;
  margin-bottom: ${({ device }) => (device === 'mobile' ? '0' : '2px')};
  background-image: url(${({ isDisabled }) => (isDisabled ? ChevronDis : ChevronDownGray)});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  transform: ${({ isOpen }) => `rotateX(${!isOpen ? '0deg' : '180deg'})`};
  transition: all 0.3s ease;
`;

const OptionsWrapper = styled.div`
  position: absolute;
  ${({ openToUp }) =>
    css`
      ${openToUp ? 'bottom:62px' : 'top:90px'}
    `};
  left: 0;
  right: 0;
  max-height: ${({ maxHeight }) => maxHeight || '390px'};
  background-color: ${select('white')};
  border: 1px solid ${select('neutralDarkGray')};
  border-radius: 8px;
  z-index: 10;
  box-shadow: 0px 2px 10px 0px #0000000d;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  padding: 8px 0;
  overflow-y: auto;
  /* Estilos del scroll */
  ::-webkit-scrollbar {
    width: 4px;
    height: 20px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
    width: 8px;
    border-radius: 3px;
    padding: 2px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${select('midDarkGrayAux')};
    border-radius: 3px;
    background-clip: content-box;
  }
`;

const OptionItem = styled.div`
  padding: 12px 16px;
  font-family: Hind;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  background-color: ${({ isHighlighted }) => (isHighlighted ? select('neutralGray') : 'transparent')};
  &:hover {
    background-color: ${select('neutralGray')};
  }
  .iconSVG {
    flex-shrink: 0;
    margin-left: 3px;
  }
`;

const Description = styled.span`
  font-family: Hind;
  font-size: 14px;
  color: ${select('black')};
  font-weight: ${({ selected }) => (selected ? '600' : '400')};
  text-overflow: ellipsis;
  overflow: hidden;
`;

const FilterInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-family: Hind;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: ${select('black')};
  background-color: transparent;
  min-width: 230px;
  &::placeholder {
    color: ${({ isDisabled }) => (isDisabled ? select('midNeutralGray') : select('midDarkGrayAux'))};
  }
`;

const NoResultsMessage = styled.div`
  padding: 12px 16px;
  font-family: Hind;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  white-space: normal;
`;

const inputStyles = css`
  label {
    display: block;
    font-family: Hind;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: ${select('black')};
    margin-bottom: 4px;
  }

  input {
    width: 100%;
    height: 48px;
    padding: 12px 8px;
    font-family: Hind;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    border: 1px solid ${select('midDarkGrayAux')};
    background-color: ${select('white')};
    border-radius: 8px;
    transition: all 0.2s ease;
    overflow: hidden;
    text-overflow: ellipsis;
    &:focus {
      outline: none;
      border-color: ${getColor('primary')};
    }

    &.error {
      border-color: ${select('redNoTRecommended')};
    }

    &::placeholder {
      color: ${select('midDarkGrayAux')};
      font-family: Hind;
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
    }

    &:disabled {
      background-color: ${select('gray')};
      cursor: not-allowed;
    }
  }
`;

const NumberInput = styled.div`
  overflow: hidden;
  ${inputStyles}
  input {
    /* Elimina las flechas de incremento/decremento */
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Para Firefox */
    -moz-appearance: textfield;
    appearance: textfield;
  }
`;

const TextInput = styled.div`
  ${inputStyles}
`;

const ErrorMessage = styled.span`
  display: block;
  color: ${select('redNoTRecommended')};
  font-family: Hind;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  margin-top: 4px;
`;

export {
  CategorySection,
  CategoryTitle,
  CategoriesGroup,
  NumberInput,
  TextInput,
  ErrorMessage,
  SelectContainer,
  SelectLabel,
  SelectHeader,
  SelectPlaceholder,
  SelectValue,
  CloseIconWrapper,
  SelectContentWrapper,
  ArrowIcon,
  OptionsWrapper,
  OptionItem,
  Description,
  FilterInput,
  NoResultsMessage
};
